import { combine, withCallback } from 'react-hooks-combine'

import ControlsComponent from './component'

export const Controls = combine(
  withCallback(
    'onOpenBinaryBetModalProxy',
    (_state, { value, onOpenBinaryBetModal }) =>
      () => {
        onOpenBinaryBetModal(value)
      },
    ['value']
  )
)(ControlsComponent)
